import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useStoreList } from 'queries/useESignQueries';
import useIsMobile from './eSignApplication/hooks/useIsMobile';
import MyColor from 'utils/MyColor';
import styled from 'styled-components';
import { ROUTES } from 'App';
import Loading from 'components/Loading';

export default function ESignScreen() {
  const navigate = useNavigate();
  const [businessNumber, setBusinessNumber] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { refetch } = useStoreList(businessNumber, false);
  const isMobile = useIsMobile();

  const search = () => {
    if (businessNumber.length != 10) {
      alert('사업자등록번호 10자리를 입력해 주세요');
      return;
    }

    moveESignApplication(businessNumber);
  };

  async function moveESignApplication() {
    setIsLoading(true);
    const { data, error } = await refetch();
    setIsLoading(false);

    if (error) {
      // 모든 error는 apiClient에서 alert 띄우고 있음
      return;
    }

    if (data.length === 0) {
      alert('계약할 매장이 존재하지 않습니다');
      return;
    }

    navigate(`${ROUTES.eSignContract}?businessNumber=${businessNumber}`);
  }

  return (
    <>
      {isLoading && <Loading />}
      <Container>
        <Form
          $isMobile={isMobile}
          onSubmit={(e) => {
            e.preventDefault(); // 새로고침 방지
            search();
          }}
        >
          <Title>꼬르륵 전자계약서 조회</Title>

          <LabelText>
            <Required>*</Required>사업자 등록번호
          </LabelText>

          <InputField
            type="number"
            value={businessNumber}
            maxLength={10}
            placeholder="사업자 번호를 기입해 주세요"
            onChange={(e) => setBusinessNumber(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && search()}
          />

          <Button>전자계약서 조회</Button>
        </Form>
      </Container>
    </>
  );
}

const Container = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f5f5f5;

  @media (max-width: 1000px) {
    background-color: #fff;
  }
`;

const Form = styled.form`
  padding: ${(props) => (props.$isMobile ? '24px' : '68px')};
  background-color: white;
  border-radius: 24px;
  box-shadow: ${(props) => (props.$isMobile ? 'none' : '0px 20px 50px rgba(0,0,0,0.25)')};
  width: 100%;
  max-width: 800px;
  height: 460px;
  display: flex;
  flex-direction: column;
`;

const Title = styled.h1`
  font-size: 40px;
  font-weight: 600;
  color: ${MyColor.brand60};
  text-align: center;
`;

const Required = styled.span`
  color: ${MyColor.brand60};
  font-weight: 600;
  font-size: 18px;
`;

const LabelText = styled.div`
  margin-top: 40px;
  font-weight: 600;
  font-size: 18px;
  color: #4c4c4c;
`;

const InputField = styled.input`
  width: 100%;
  margin-top: 4px;
  padding: 17px 12px;
  border-radius: 6px;
  border: 1px solid #ccc;
  font-size: 14px;
  color: #333;
`;

const Button = styled.button`
  margin-top: auto;
  width: 100%;
  height: 48px;
  border-radius: 8px;
  background-color: ${MyColor.brand60};
  color: white;
  font-weight: bold;
  font-size: 16px;
`;
